module.exports = __webpack_public_path__ + "img/icono_science.42d64353.svg";